// Simple event emitter
//
// https://gist.github.com/contra/2759355

export class EventEmitter {
  constructor() {
    this.events = {};
  }

  emit(event, ...args) {
    if (!this.events[event]) {
      return false;
    }
    for (const listener of Array.from(this.events[event])) {
      listener(...Array.from(args || []));
    }
    return true;
  }

  addListener(event, listener) {
    this.emit("newListener", event, listener);
    (this.events[event] != null
      ? this.events[event]
      : (this.events[event] = [])
    ).push(listener);
    return this;
  }

  on(event, listener) {
    return this.addListener(event, listener);
  }

  once(event, listener) {
    const fn = function () {
      this.removeListener(event, fn);
      return listener(...arguments);
    }.bind(this);
    this.on(event, fn);
    return this;
  }

  removeListener(event, listener) {
    if (!this.events[event]) {
      return this;
    }
    this.events[event] = Array.from(this.events[event]).filter(
      (l) => l !== listener
    );
    return this;
  }

  removeAllListeners(event) {
    delete this.events[event];
    return this;
  }
}
